'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = DiscussionCardList;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _DiscussionCard = require('./DiscussionCard');

var _DiscussionCard2 = _interopRequireDefault(_DiscussionCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 */
function DiscussionCardList(_ref) {
	var title = _ref.title;
	var discussions = _ref.discussions;
	var onSelect = _ref.onSelect;
	var onStatusChange = _ref.onStatusChange;
	var user = _ref.user;

	return _react2.default.createElement(
		'section',
		{ className: 'vtChat-DiscussionCardList' },
		_react2.default.createElement(
			'header',
			{ className: 'vtChat-DiscussionCardList-header' },
			_react2.default.createElement(
				'h2',
				{ className: 'vtChat-DiscussionCardList-title' },
				title
			)
		),
		_react2.default.createElement(
			'ul',
			{ className: 'vtChat-DiscussionCardList-list' },
			(0, _lodash.map)(discussions, function (_ref2) {
				var id = _ref2.id;

				var discussion = _objectWithoutProperties(_ref2, ['id']);

				return _react2.default.createElement(
					'li',
					{ className: 'vtChat-DiscussionCardList-item', key: id },
					_react2.default.createElement(_DiscussionCard2.default, _extends({}, discussion, {
						id: id,
						onClick: (0, _lodash.partial)(onSelect, id),
						onStatusChange: (0, _lodash.partial)(onStatusChange, id, user)
					}))
				);
			})
		)
	);
}

DiscussionCardList.propTypes = {
	title: _react.PropTypes.node.isRequired,
	discussions: _react.PropTypes.array.isRequired,
	onSelect: _react.PropTypes.func,
	onStatusChange: _react.PropTypes.func
};

DiscussionCardList.defaultProps = {
	onSelect: _lodash.noop,
	onStatusChange: _lodash.noop
};